const cards = [
  {
    title: '最新电影速递',
    desc: '每日同步全球热门新片资讯，从好莱坞大片到独立佳作，第一时间呈现最新电影动态，让你不再错过任何一部好片。',
    icon: 'ri-rocket-2-fill',
    tag: '每日更新',
    img: 'https://readdy.ai/api/search-image?query=Modern%20cinema%20theater%20interior%20with%20red%20velvet%20seats%2C%20large%20blank%20screen%2C%20warm%20ambient%20lighting%2C%20luxurious%20atmosphere%2C%20clean%20minimal%20composition%2C%20professional%20photography&width=800&height=450&seq=card-img-1&orientation=landscape'
  },
  {
    title: '高清画质专区',
    desc: '全站提供1080P及以上高清免费在线观看体验，智能自适应码率确保流畅不缓冲，让每帧画面都纤毫毕现。',
    icon: 'ri-4k-fill',
    tag: '蓝光品质',
    img: 'https://readdy.ai/api/search-image?query=High%20definition%20film%20projection%20room%20with%20vibrant%20colors%2C%20crystal%20clear%20display%2C%20modern%20home%20theater%20setup%2C%20soft%20ambient%20light%2C%20professional%20equipment%2C%20clean%20aesthetic&width=800&height=450&seq=card-img-2&orientation=landscape'
  },
  {
    title: '热门电影排行榜',
    desc: '基于全网热度与观众口碑综合排序，实时更新热门电影排行榜。动作爽片、悬疑烧脑、温情治愈，各类榜单一目了然。',
    icon: 'ri-bar-chart-2-fill',
    tag: '实时排行',
    img: 'https://readdy.ai/api/search-image?query=Movie%20ranking%20leaderboard%20concept%20with%20golden%20trophy%20and%20film%20strips%2C%20warm%20spotlight%20effect%2C%20elegant%20dark%20background%2C%20premium%20cinematic%20feel%2C%20minimalist%20design&width=800&height=450&seq=card-img-3&orientation=landscape'
  },
  {
    title: '分类索引大全',
    desc: '按类型、地区、年代多维度精准导航，电影大全片库一应俱全。无论想找经典老片还是冷门佳作，分类索引都能帮你快速定位。',
    icon: 'ri-folder-open-fill',
    tag: '多维检索',
    img: 'https://readdy.ai/api/search-image?query=Organized%20film%20archive%20library%20with%20categorized%20shelves%2C%20warm%20vintage%20lighting%2C%20wooden%20cabinets%2C%20neat%20organization%2C%20cozy%20atmosphere%2C%20intellectual%20vibe&width=800&height=450&seq=card-img-4&orientation=landscape'
  },
  {
    title: '精彩预告抢先看',
    desc: '汇集最新上映电影预告片与幕后花絮，高清画质一睹为快。帮你提前锁定心仪影片，观前必看指南。',
    icon: 'ri-film-fill',
    tag: '独家预告',
    img: 'https://readdy.ai/api/search-image?query=Movie%20trailer%20preview%20scene%20with%20dramatic%20lighting%20effects%2C%20cinematic%20wide%20shot%2C%20exciting%20atmosphere%2C%20dynamic%20composition%2C%20theater%20screen%20glowing%2C%20professional%20cinematography&width=800&height=450&seq=card-img-5&orientation=landscape'
  },
  {
    title: '观影社区互动',
    desc: '与影迷一起讨论剧情、分享影评。每部电影都有专属评论区，热门电影讨论区每天产生上千条精彩影评。',
    icon: 'ri-chat-smile-2-fill',
    tag: '影迷聚集',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20movie%20discussion%20lounge%20with%20warm%20ambient%20lighting%2C%20comfortable%20seating%2C%20film%20posters%20on%20walls%2C%20friendly%20social%20atmosphere%2C%20modern%20interior%20design&width=800&height=450&seq=card-img-6&orientation=landscape'
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            海量片库 · 一站畅享
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            六大核心板块覆盖找片、看片、聊片全流程，打造你的专属电影大全体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-100 relative">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs rounded-full whitespace-nowrap">
                    <i className={`${card.icon} text-xs`}></i>
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}